<template>
  <div class="mt-3">
    <div v-for="material in materials" :key="material.id" class="card card-no-padding card-body mt-3">
      <app-material :material="material"></app-material>
    </div>
  </div>
</template>

<script>
  import Material from '@/components/Order/Material.vue'

  export default {
    data() {
      return {}
    },
    components: {
      'app-material': Material
    },
    computed: {
      materials() {
        return !this.$store.getters.cartMaterials ? [] : this.$store.getters.cartMaterials
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
